<template>
  <v-snackbar
    v-model="show"
    color="error"
    timeout="-1"
    top
    class="mt-12"
  >
    {{ message }}
    <v-btn
      text
      @click="close()"
    >
      {{ $t('common.close') }}
    </v-btn>
  </v-snackbar>
</template>
<script>
export default {
  props: {
    message: {
      type: String,
      default: '',
    },
  },
  computed: {
    show() {
      return !!this.message;
    },
  },
  methods: {
    close() {
      this.$store.commit('showErrorMessage', { message: '' });
    },
  },
};
</script>
